import { CodeBook } from "@king-ict/eupisi-ui/models/Common/CodeBook";

export interface Group extends CodeBook {
  faqApplicationDisplayId: number;
  status: boolean;
}

export enum FaqApplicationDisplay {
  public = 1,
  admin = 2,
  both = 3,
}
